import ServiceBase from './serviceBase';
import { FlowCommentCreate, FlowCommentsFilter, FlowCommentList } from './types/Flow';

class OperEsmrCommentsService extends ServiceBase {
  create = async (data: FlowCommentCreate): Promise<void> =>
    this.post<void>('esmrcomment/create', data);

  getList = async (filter: FlowCommentsFilter): Promise<FlowCommentList> =>
    this.post<FlowCommentList>('esmrcomment/list', filter);

  exportExcel = async (operationId: number): Promise<boolean> => {
    await this.download(`esmrcomment/excel/${operationId}`, undefined, true);
    return true;
  };
}

const operEsmrCommentsService = new OperEsmrCommentsService();

export default operEsmrCommentsService;
